// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2ehFa","header":"PatientQuestionnaire_header__3mUNJ","info":"PatientQuestionnaire_info__1iHKM"};